import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LanguageComponent } from "../language/language.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  standalone: true,
    selector: "app-topbar",
    templateUrl: "./topbar.component.html",
    styleUrls: ["./topbar.component.scss"],
    imports: [
    CommonModule, LanguageComponent,
    TranslateModule]
})
export class TopbarComponent {
  @Input() data: any | null;
  // Toggle to true if we need to re-enable the top header/language selector.
  readonly showTopbar = false;
}
